import React, { useState, useEffect } from "react";
import { Tab, Nav, Form } from "react-bootstrap";
import Header from "../../Components/Header";
import OnboardingPendingCard from "../../../src/Pages/Onboarding/OnboardingPendingCard";
import OnboardingCompleted from "./OnboardingCompleted";
import OnboardingCreatedClient from "./OnboardingCreatedClient";
import OnboardingRejected from "./OnboardingRejected";
import OnboardingRaiseIssue from "./OnboardingRaiseIssue";
import OnboardingNotInterested from "./OnboardingNotInterested";
import axios from "axios";
import Filter from "./Filter";
import Loader from "../../Components/Common/Loader";
import { useNavigate } from "react-router-dom";
import { Client_Search, Onboarding_Page } from "../../Configuration/API_URL";
import { Constants } from "../../CommonMethhods/Constants";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { toast } from "react-toastify";
import SmallLoader from "../../Components/Common/smallLoader";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../CommonMethhods/CommonMethods";
import { useDebounce } from "../../Components/useDebounce";

function OnboardingPendingNew(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [linecard, setLinecard] = useState("block-active col-division-5");
  const [loader, setLoader] = useState(false);
  const [tabStatus, setTabStatus] = useState("Created");
  const [search, setSearch] = useState();
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [filterData, setFilterData] = useState("HNI");
  const [onboardingData, setOnboardingData] = useState([]);
  const [serverError, setServerError] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [smallLoaderPdf, setPdfLoader] = useState(false);
  const [smallLoaderExcel, setExcelLoader] = useState(false);
  const debouncedValue = useDebounce(search, 1000);
  useEffect(() => {
    handleSearch(debouncedValue);
  }, [debouncedValue]);

  let navigate = useNavigate();
  localStorage.setItem("statusOfClient", tabStatus);
  if (storeToken == null) {
    window.location.replace("/");
    // localStorage.clear("");
  }
  function handleGridView(e) {
    if (linecard === "") setLinecard("block-active col-division-5");
  }

  function handleListView() {
    if (linecard === "block-active col-division-5") setLinecard("");
  }

  const onboardingApiData = async (
    pageNo = 1,
    tab,
    viewType = "grid",
    sizePage = 10,
    searchVal = ""
  ) => {
    let finalStatus;

    if (viewType === "grid" && page === 1) {
      setLoader(true);
    }

    if (viewType === "pdf") {
      setPdfLoader(true);
    }
    if (viewType === "excel") {
      setExcelLoader(true);
    }

    if (localStorage.getItem("activeTab")) {
      finalStatus = localStorage.getItem("activeTab");
    } else {
      finalStatus = tab;
    }

    let payloadValue = {
      status: finalStatus,
      pageSize: sizePage,
      pageNo: pageNo,
      type: filterData,
      fileType: viewType,
      searchKey: searchVal
    };
    let encPayload = AESEncryption(payloadValue);
    console.log("payload value", payloadValue)
    try {
      const getOnboardingDetails = await axios.post(
        Onboarding_Page.OnbOarding_URL_NEW,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getOnboardingDetails?.data);
      if (res?.status === 0) {
        setServerError(false);
        console.log("res onboarding", res)
        if (viewType === "grid") {
          setTotalCount(res?.data?.totalcount);
          if(res?.data?.all.length> 0){
            setServerError(false)
          if (pageNo > 1) {
            setOnboardingData((prev) => {
              return [...prev, ...res?.data.all];
            });
          } else {
            setOnboardingData(res?.data.all);
          }
        }
        else{
          setOnboardingData(res?.data.all)
          setServerError("No Data Found")
        }


        }

        if (viewType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
        if (viewType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        if (viewType !== "grid") {
          toast.error(res?.message);
        } else {
          setOnboardingData([]);
          setServerError(res?.message);
        }
      }
    } catch (error) {
      setServerError(error?.message);
    } finally {
      setLoader(false);
      setScrollLoader(false);
      setExcelLoader(false);
      setPdfLoader(false);
    }
  };

  // for pagination start

  const handleScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(totalCount <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
        setLoader(false);
      }
    }
  };

  // for pagination end

  useEffect(() => {
    if (localStorage.getItem("activeTab")) {
      setTabStatus(localStorage.getItem("activeTab"));
    }
    onboardingApiData(page, tabStatus, "grid", 10);

    // return () => {
    //   localStorage.removeItem("activeTab");
    //   localStorage.removeItem("statusOfClient");

    // };
  }, [page, filterData, tabStatus]);

  function updateStatus(res) {
    setOnboardingData(res);
  }

  function handleTabStatus(status) {
    setTabStatus(status);
    setPage(1);
    setSearch("")
    localStorage.setItem("statusOfClient", tabStatus);
    localStorage.setItem("activeTab", status)
  }

  const handleOnChange = (e) => {
    setPage(1);
    setTabStatus("Created");
    if (e.target.value) {
      setFilterData(e.target.value);
      setOnboardingData([]);
      setSearch("");
    }
  };
  const handleSearch = (val) => {
    onboardingApiData(1, tabStatus, "grid", -1, val);
  }

  const handleOnClick = (e) => {
    if (e.target.value) {
      onboardingApiData(1, tabStatus, e.target.value, -1, search);
    }
  };

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="onboarding-pending">
        <div className="card-right card-tabs">
          <div className="dropdown-filter">
            <Form.Select
              size="lg"
              aria-label="Default select example"
              onChange={handleOnChange}
            >
              <option value="HNI">HNI</option>
              <option value="Retail">Retail</option>
            </Form.Select>
          </div>
        </div>

        <div className="tab-content" id="myTabContent">
          <Tab.Container id="left-tabs-example" activeKey={tabStatus}>
            {/* page tabs */}
            <div>
              <Nav variant="nav tabs page-tabs">
                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("Created")}
                >
                  <Nav.Link eventKey="Created">{Constants.Created}</Nav.Link>
                </li>
                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("Pending")}
                >
                  <Nav.Link eventKey="Pending">{Constants.Pending}</Nav.Link>
                </li>
                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("Completed")}
                >
                  <Nav.Link eventKey="Completed">
                    {Constants.Submitted}
                  </Nav.Link>
                </li>

                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("Rejected")}
                >
                  <Nav.Link eventKey="Rejected">{Constants.Rejected}</Nav.Link>
                </li>
                {/* <li
                  className="nav-item"
                  onClick={() => handleTabStatus("NotInterested")}
                >
                  <Nav.Link eventKey="NotInterested">
                    {Constants.NotInterested}
                  </Nav.Link>
                </li>
                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("RaiseIssue")}
                >
                  <Nav.Link eventKey="RaiseIssue">
                    {Constants.Raise_Issue}
                  </Nav.Link>
                </li> */}
              </Nav>
            </div>
            {/* page tabs end */}

            {/* page search and filters start ,menu */}
            <div className="onboarding-secondary-tab-list">
              <div className="search-box"></div>

              <div className="menu-rank-wrapper">
                {tabStatus !== "Created" &&
                  <div className="form-group" id="search-onboarding">
                    <div className="for-position">
                      <input
                        type="text"
                        name="search-text"
                        id="SearchInput"
                        className="input-st onboarding"
                        placeholder="Search here..."
                        autoComplete="off"
                        value={search}

                        // handleSearch(e);
                        onChange={(e) => {
                          setSearch(e.target.value.toLowerCase());

                        }}

                      />
                    </div>
                  </div>}
                <div className="menu-wrapper">
                  <span
                    className="icon-block-menu"
                    onClick={handleGridView}
                  ></span>
                  <span
                    className="icon-horizontal-menu"
                    onClick={handleListView}
                  ></span>
                </div>
                <div className="onBoarding-Excel-Pdf">
                  <div className="btn-wrapper-summary">
                    <button
                      value="excel"
                      onClick={handleOnClick}
                      className="summary-btn excel-btn"
                    >
                      {smallLoaderExcel ? (
                        <div>
                          <SmallLoader />
                        </div>
                      ) : (
                        <>
                          <span className="icon-excelsvg"></span>
                          Excel
                        </>
                      )}
                    </button>
                    <button
                      className="summary-btn pdf-btn"
                      value="pdf"
                      onClick={handleOnClick}
                    >
                      {smallLoaderPdf ? (
                        <div>
                          <SmallLoader />
                        </div>
                      ) : (
                        <>
                          <span className="icon-pdfsvg"></span>
                          PDF
                        </>
                      )}
                    </button>
                  </div>
                </div>

                <div className="filter-btn-wrapper">
                  <Filter tabStatus={tabStatus} updateStatus={updateStatus} />
                </div>
              </div>
            </div>
            <div className="for-grid-section">
              {loader ? (
                <div className="loader-alignment">
                  <Loader />
                </div>
              ) : (
                <Tab.Content>
                  <OnboardingCreatedClient
                    checkCreatedClient={onboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                    serverError={serverError}
                    filterData={filterData}
                  />
                  <OnboardingPendingCard
                    checkPending={onboardingData}
                    linecard={linecard}
                    scrollLoader={scrollLoader}
                    handleScroll={handleScroll}
                    serverError={serverError}
                    filterData={filterData}
                  />
                  <OnboardingCompleted
                    checkCompleted={onboardingData}
                    linecard={linecard}
                    scrollLoader={scrollLoader}
                    handleScroll={handleScroll}
                    serverError={serverError}
                    filterData={filterData}
                  />

                  <OnboardingRejected
                    checkRejected={onboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                    serverError={serverError}
                    filterData={filterData}
                  />
                  {/* <OnboardingNotInterested
                    checkNotInterested={onboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                    serverError={serverError}
                  />
                  <OnboardingRaiseIssue
                    checkRaiseIssue={onboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                    serverError={serverError}
                  /> */}
                </Tab.Content>
              )}
            </div>
          </Tab.Container>
        </div>
      </main>
    </>
  );
}

export default OnboardingPendingNew;
